import React from 'react';
import { REDUCER_NAME as COMMON_REDUCER_NAME } from '../../../app/commonReducer';
import { Search } from '../../../common/mix-search/index';
import { connect } from 'react-redux';
import ConstCommon from './../../../common/Const';
import { REDUCER_NAME, setCurrentSearch } from './reducer';

class SearchBox extends React.PureComponent {
  clickItemSearch = currentSearch => {
    const { setCurrentSearch } = this.props;
    setCurrentSearch(currentSearch || {});
  };

  render() {
    const {
      listSearch,
      typeSearch,
      dateRangeOption,
      disabled,
      currentSearch,
    } = this.props;

    return (
      <Search
        disabled={disabled}
        listSearch={listSearch}
        listKeyFilter={[
          ConstCommon.listOrganization.TICKER,
          ConstCommon.listOrganization.ORGAN_SHORT_NAME,
        ]}
        currentSearch={currentSearch}
        typeSearch={typeSearch}
        dateRangeOption={dateRangeOption}
        clickItemSearch={this.clickItemSearch}
        mainKey={'ticker'}
        sortKey={'ticker'}
        enableSearchByTicker={true}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    listSearch: state[COMMON_REDUCER_NAME].listOrganizationSearch,
    currentSearch: state[REDUCER_NAME].currentSearch,
  };
};

const mapDispatchToProps = {
  setCurrentSearch,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SearchBox);
